import React from "react";

const API =
  "https://agriculture.vic.gov.au/_design/data-files/safety-alerts-data.json";

class Alerts extends React.Component {
  constructor(props) {
    super();
    this.state = {alertState: "disabled"};
  }

  componentDidMount() {
    fetch(API)
      .then(response => response.json())
      .then(data => {
        this.setState({
          alertState: data.alertState,
          openClosed: data.openClosed,
          heading: data.heading,
          alert: data.alert,
          url: data.url,
          viewall: data.viewall,
          viewallurl: data.viewallurl
        });

        if (document.cookie.indexOf("agalerts=1") > -1) {
          this.setState({
            openclosed: "open"
          });
        } else {
          this.setState({
            openclosed: "closed"
          });
        }
      });
  }

  close = () => {
    this.setState({
      openclosed: "open"
    });
    var d = new Date();
    document.cookie = "agalerts=1; expires=" + d.getTime() + 31556952;
  };

  open = () => {
    this.setState({
      openclosed: "closed"
    });
    var d = new Date();
    document.cookie = "agalerts=1 ; expires =" + d.toGMTString();
  };

  render() {
    return (
      <div>
        <div
          id="alerts"
          className={this.state.alertState + " " + this.state.openclosed}
        >
          <div className="container-fluid alerts-container">
            <div className="row">
              <div className="safety-alerts-heading">
                <span className="alert-heading">{this.state.heading}: </span>
              </div>
              <div className="col-sm-12 order-3 col-md-9 safety-alerts-main">
                <a href={this.state.url}>{this.state.alert}</a>
              </div>
            </div>
          </div>
          <button
            type="button"
            className="fa fa-window-close close-button"
            aria-label="Close"
            onClick={this.close}
          ></button>
        </div>
        <div className={this.state.openclosed + " open-alert"}>
          <button
            className="open-alert-icon"
            aria-label="Open alert"
            onClick={this.open}
          ></button>{" "}
        </div>
      </div>
    );
  }
}

export default Alerts;
